import { getWordpressPostList } from "@src/functions/wordpress";
import WordpressPostList from "../common/components/WordpressPostList";

export async function getServerSideProps() {
  const postJson = await getWordpressPostList("1411");
  return {
    props: { data: postJson },
  }
}

function CaseStudies ({ data }: any) {
  return (
    <WordpressPostList
      group="case-studies"
      titleName="Case Studies"
      listTitle="Case Studies"
      data={data}
    />
  );
};

export default CaseStudies;